/* Piave · Cotacao de frete na PDP — CEP -> estado (ViaCEP) -> adiciona -> cota (Shopify) -> restaura */
(function () {
  if (customElements.get('frete-calc')) return;

  function money(v) {
    var n = parseFloat(v);
    if (isNaN(n)) return v;
    return 'R$ ' + n.toFixed(2).replace('.', ',');
  }
  function maskCep(v) {
    v = (v || '').replace(/\D/g, '').slice(0, 8);
    return v.length > 5 ? v.slice(0, 5) + '-' + v.slice(5) : v;
  }
  function fmtDate(iso) {
    if (!iso) return '';
    var d = new Date(iso + 'T00:00:00');
    if (isNaN(d)) return '';
    return ('0' + d.getDate()).slice(-2) + '/' + ('0' + (d.getMonth() + 1)).slice(-2);
  }
  function prazo(r) {
    var d = r.delivery_days;
    if (Array.isArray(d)) {
      var min = d[0], max = d[d.length - 1];
      if (min == null && max == null) d = null;
      else if (min !== max) return min + ' a ' + max + ' dias úteis';
      else d = min;
    }
    if (d != null) return d + (d === 1 ? ' dia útil' : ' dias úteis');
    var dt = fmtDate(r.delivery_date);
    return dt ? 'chega até ' + dt : '';
  }

  function escapar(s) {
    return String(s).replace(/[&<>"']/g, function (c) { return ({ '&':'&amp;', '<':'&lt;', '>':'&gt;', '"':'&quot;', "'":'&#39;' })[c]; });
  }
  function diasMax(r) {
    var d = r.delivery_days;
    if (Array.isArray(d)) d = d[d.length - 1];
    d = parseInt(d, 10);
    return isNaN(d) ? null : d;
  }

  /* Expresso > Rápido > Normal, sempre com todas as opções da Frenet e sem o nome da
     transportadora (pedido do Lucas, 10/09). A que chega antes é Expresso, a que chega por
     último é Normal. No mesmo prazo, a mais cara fica na faixa de cima.
     Prazo e preço são os da tarifa, os mesmos que o checkout cobra. Saindo do Ipiranga, para SP
     o Sedex (4 dias, R$ 11,03) custa menos que o PAC (8 dias, R$ 17,15), então lá o Expresso sai
     mais barato que o Normal. Isso só muda na tarifa da Frenet, não aqui.
     Se um dia vierem mais de três: a mais rápida, a mais barata do meio e a mais lenta. */
  function faixas(rates) {
    var vistas = {};
    var lista = rates.map(function (r) {
      var dias = diasMax(r);
      return { rate: r, dias: dias == null ? Infinity : dias, preco: parseFloat(r.price) };
    }).filter(function (o) {
      var k = o.dias + '|' + o.preco;
      if (vistas[k]) return false;
      vistas[k] = 1;
      return true;
    });
    lista.sort(function (a, b) { return (a.dias - b.dias) || (b.preco - a.preco); });
    if (lista.length > 3) {
      var meio = lista.slice(1, -1).sort(function (a, b) { return a.preco - b.preco; })[0];
      lista = [lista[0], meio, lista[lista.length - 1]];
    }
    var nomes = lista.length === 3 ? ['Expresso', 'Rápido', 'Normal'] : lista.length === 2 ? ['Expresso', 'Normal'] : ['Normal'];
    lista.forEach(function (o, i) { o.rotulo = nomes[i]; });
    return lista;
  }

  class FreteCalc extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('.frete__form');
      this.input = this.querySelector('.frete__cep');
      this.btn = this.querySelector('.frete__btn');
      this.msg = this.querySelector('.frete__msg');
      this.results = this.querySelector('.frete__results');
      var self = this;
      this.input.addEventListener('input', function () { self.input.value = maskCep(self.input.value); });
      this.form.addEventListener('submit', function (e) { e.preventDefault(); self.calc(); });
    }

    variantId() {
      var f = document.querySelector('form[action*="/cart/add"] [name="id"], product-form [name="id"]');
      if (f && f.value) return f.value;
      return this.dataset.variant;
    }

    show(text, isErr) {
      this.msg.hidden = false;
      this.msg.textContent = text;
      this.msg.classList.toggle('is-error', !!isErr);
      this.results.hidden = true;
      this.results.innerHTML = '';
    }

    async calc() {
      var cep = (this.input.value || '').replace(/\D/g, '');
      if (cep.length !== 8) { this.show('Digite um CEP válido (8 dígitos).', true); return; }
      var vid = this.variantId();
      if (!vid) { this.show('Selecione uma variação primeiro.', true); return; }

      this.btn.disabled = true;
      this._label = this._label || this.btn.textContent;
      this.btn.textContent = 'Calculando...';
      this.results.hidden = true; this.results.innerHTML = '';
      this.msg.hidden = false; this.msg.classList.remove('is-error'); this.msg.textContent = 'Calculando frete e prazo...';

      var restoreQty = 0, added = false;
      try {
        // 1) CEP -> estado (UF) + cidade
        var loc = null;
        try { loc = await fetch('https://viacep.com.br/ws/' + cep + '/json/').then(function (r) { return r.json(); }); } catch (e) {}
        if (!loc || loc.erro || !loc.uf) { this.show('CEP não encontrado. Verifique o número.', true); return; }
        var uf = loc.uf, cidade = loc.localidade || '';

        // 2) snapshot + adiciona a variacao
        var cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
        (cart.items || []).forEach(function (it) { if (String(it.id) === String(vid)) restoreQty = it.quantity; });
        var addRes = await fetch('/cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: vid, quantity: 1 })
        });
        if (!addRes.ok) throw new Error('add');
        added = true;

        // 3) cota no Shopify (country precisa ser "Brazil" + province = UF)
        var url = '/cart/shipping_rates.json?shipping_address[zip]=' + cep +
                  '&shipping_address[country]=Brazil&shipping_address[province]=' + encodeURIComponent(uf);
        var rates = null, tries = 0;
        while (tries < 6) {
          var res = await fetch(url, { headers: { Accept: 'application/json' } });
          if (res.status === 200) { var data = await res.json(); rates = data.shipping_rates; if (rates) break; }
          else if (res.status === 422) { throw new Error('addr'); }
          await new Promise(function (r) { setTimeout(r, 700); });
          tries++;
        }
        if (!rates || !rates.length) this.show('Sem frete disponível para esse CEP no momento. Veja no checkout.', true);
        else this.render(rates, cidade, uf);
      } catch (err) {
        if (err && err.message === 'add') this.show('Produto indisponível para cálculo agora.', true);
        else this.show('Não foi possível calcular agora. O frete aparece no checkout.', true);
      } finally {
        if (added) {
          try {
            await fetch('/cart/change.js', {
              method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ id: vid, quantity: restoreQty })
            });
          } catch (e) {}
        }
        this.btn.disabled = false;
        this.btn.textContent = this._label || 'Calcular';
      }
    }

    render(rates, cidade, uf) {
      this.msg.hidden = true;
      this.results.innerHTML = '';
      if (cidade || uf) {
        var head = document.createElement('li');
        head.className = 'frete__dest';
        head.textContent = 'Frete para ' + (cidade ? cidade + ' - ' : '') + uf;
        this.results.appendChild(head);
      }
      var self = this;
      faixas(rates).forEach(function (o) {
        var r = o.rate;
        var li = document.createElement('li');
        li.className = 'frete__row';
        var d = prazo(r);
        li.innerHTML =
          '<span class="frete__name">' + escapar(o.rotulo) + '</span>' +
          (d ? '<span class="frete__days">' + d + '</span>' : '') +
          '<span class="frete__price">' + money(r.price) + '</span>';
        self.results.appendChild(li);
      });
      this.results.hidden = false;
    }
  }
  customElements.define('frete-calc', FreteCalc);
})();
